import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Spinner } from "../../shared/ui";
import { decodeArrayBufferWithBOM } from "./TextUtils";

const TxtViewer = ({ fileUrl }) => {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadFailed, setLoadFailed] = useState(false);

  useEffect(() => {
    if (!fileUrl) {
      setText("No file URL provided.");
      setLoading(false);
      return;
    }

    setLoading(true);
    setLoadFailed(false);
    fetch(fileUrl)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.arrayBuffer();
      })
      .then((arrayBuffer) => {
        const decodedText = decodeArrayBufferWithBOM(arrayBuffer);
        setText(decodedText);
      })
      .catch((error) => {
        console.error("Failed to fetch or decode text file:", error);
        setLoadFailed(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [fileUrl]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-full w-full py-10">
        <Spinner />
      </div>
    );
  }

  if (loadFailed) {
    return <div className="text-status-critical font-semibold p-4">Could not load the file content.</div>;
  }

  return (
    <div className="w-full flex flex-col bg-gray-50 h-[70vh] overflow-y-auto">
      <div className="w-full min-h-full p-6 text-ink bg-white border border-line rounded-lg">
        <pre className="font-mono text-sm leading-relaxed whitespace-pre-wrap break-words font-sans">
          {text}
        </pre>
      </div>
    </div>
  );
};

TxtViewer.propTypes = {
  fileUrl: PropTypes.string.isRequired,
};

export default TxtViewer;
